<template lang="pug">
.comments
  .comments-head
    SelectGroup(
      v-model="choosen"
      :fields="selectData"
      placeholder="Выберите курс для проверки"
    )
    SelectCourse(
      v-model="taskInfo"
      :selectData="choosen"
      :fields="courseData"
      placeholder="Выберите раздел для проверки"
    )
    //- Search(v-model="search" :taskInfo="taskInfo")
    Select.group__select(
      v-model="filter.value"
      :selectData="filter.option"
      @input="getComment"
    )
  .comments-body(
    ref="body"
  )
    EmptyCards(
      v-if="fetchingCommentsList && !comments.length")
    CommentsCards(
      v-else-if="comments.length"
      :title="filterName"
      :course="courseName"
      :comments="comments"
      :taskBlock="taskBlock"
      :choosen="choosen"
    )
    TableEmpty(v-else style="top: 40%")
</template>
<script>
import { mapActions, mapState } from 'vuex';
import SelectGroup from './components/Select/Select';
import SelectCourse from './components/Select/SelectCourse';
import Search from './components/Search';
import CommentsCards from './components/Card';
import EmptyCards from './components/Card/EmptyCards';

export default {
  components: {
    SelectGroup,
    SelectCourse,
    Search,
    CommentsCards,
    EmptyCards
  },
  data() {
    return {
      taskInfo: {},
      choosen: '',
      search: '',
      page: 1,
      observerOptions: {
        root: null,
        threshold: 0,
        rootMargin: '0px'
      },
      observer: '',
      target: '',
      filter: {
        value: 'all',
        option: [
          {
            text: 'Все',
            value: 'all'
          },
          {
            text: 'Новые',
            value: '0'
          },
          {
            text: 'Старые',
            value: '1'
          }
        ]
      }
    };
  },
  computed: {
    ...mapState('answersValidatingFeed', {
      selectData: s => s.data.selectData,
      courseData: s => s.data.courseData
    }),
    ...mapState('answersComments', {
      comments: s => s.data.comments.comments,
      fetchingCommentsList: s => s.meta.fetchingCommentsList,
      hasMoreComments: s => s.meta.hasMoreComments
    }),
    commentsUnread() {
      return this.comments.filter(comment => !comment.id);
    },
    commentsRead() {
      return this.comments.filter(comment => comment.id);
    },
    courseName() {
      const course = this.courseData.find(
        course => course.id === this.taskInfo.id
      );
      return course ? course.systemName : false;
    },
    taskBlock() {
      return {
        variety: this.taskInfo.variety,
        id: this.taskInfo.id
      };
    },
    filterName() {
      return this.filter.option.find(
        option => option.value === this.filter.value
      ).text;
    }
  },
  watch: {
    choosen() {
      this.destroyComments();
      this.getTaskListData(this.choosen);
      this.taskInfo = {};
      if (!this.choosen) {
        this.fetchAllCommentsList();
      }
    },
    async taskInfo() {
      if (this.taskInfo.id) {
        this.getComment();
      }
    },
    fetchingCommentsList(val) {
      this.$nextTick(() => {
        if (!val && this.hasMoreComments) {
          this.observerFunction();
        }
      });
    },
    '$route.query'() {
      // this.getFeedTasks(this.taskInfo)
    }
  },
  mounted() {
    this.getTaskListCourse();
    if (!this.choosen) {
      this.fetchAllCommentsList();
    }
  },
  destroyed() {
    this.destroyComments();
  },
  methods: {
    ...mapActions('answersValidatingFeed', [
      'getTaskListCourse',
      'getTaskListData',
      'getFeedTasks'
    ]),
    ...mapActions('answersComments', [
      'fetchCommentsList',
      'clearCommentsList'
    ]),
    fetchAllCommentsList() {
      const state = this.filter.value === 'all' ? undefined : this.filter.value;

      this.$store.dispatch('answersComments/fetchAllCommentsList', {
        // userId: ,
        page: this.page++,
        pageLimit: 20,
        state
      });
    },
    //Отличается от fetchComment тем, что чистим старые комменты
    getComment() {
      if (
        this.taskBlock.id === undefined ||
        this.taskBlock.variety === undefined
      ) {
        if (!this.choosen) {
          this.destroyComments();
          this.fetchAllCommentsList();
          return;
        } else {
          return;
        }
      }
      this.destroyComments();
      const state = this.filter.value === 'all' ? undefined : this.filter.value;
      this.fetchCommentsList({
        taskBlock: this.taskBlock,
        page: this.page++,
        pageLimit: 20,
        state
      });
    },
    fetchComment() {
      if (
        this.taskBlock.id === undefined ||
        this.taskBlock.variety === undefined
      ) {
        if (!this.choosen) {
          // тут мы подгружаем дополнительные комментарии
          // с запроса на все комменты (без выбранного курса)
          this.fetchAllCommentsList();
          return;
        } else {
          return;
        }
      }
      const state = this.filter.value === 'all' ? '' : this.filter.value;
      this.fetchCommentsList({
        taskBlock: this.taskBlock,
        page: this.page++,
        pageLimit: 20,
        state
      });
    },
    observerFunction() {
      if (!this.comments.length) {
        return;
      }

      this.observer = new IntersectionObserver(
        this.handleObserver,
        this.observerOptions
      );
      this.target = document.querySelector(
        '.comments-list__cards > .comments-card:last-child'
      );
      this.observer.observe(this.target);
    },
    handleObserver(entries, observer) {
      const entry = entries[0];
      if (entry.isIntersecting) {
        observer.unobserve(entry.target);
        this.fetchComment();
      }
    },
    destroyComments() {
      if (this.observer) {
        this.observer.disconnect();
      }
      this.clearCommentsList();

      this.page = 1;

      this.$store.dispatch('answersComments/setMeta', {
        path: 'fetchingCommentsList',
        value: false
      });
      this.$store.dispatch('answersComments/setMeta', {
        path: 'hasMoreComments',
        value: true
      });
    }
  }
};
</script>
